module.exports = __webpack_public_path__ + "400bdd8b4e0d38fb0caf1b7b0674cfab.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/photo-backgrounds/animals/Lion2.jpg
// module id = 3473
// module chunks = 0